import { Link } from "react-router-dom";

const NoPlans = () => {
  return (
    <div className="grid-container">
      <div className="grid-x section__content-rail align-center text-center margin-0">
        <h2 className="h3 cell text-uppercase text-center">we're so sorry</h2>
        <p
          className="cell small-12 medium-7"
          style={{ fontSize: 25, paddingBottom: 20, lineHeight: "32px" }}
        >
          It looks like you've entered a ZIP code that's not in our coverage
          area. Give us a call, and we'd be happy to assist you further in your
          search. <a href="tel:18882938272">1-888-293-8272</a> (TTY: 711)
        </p>
        <div className="cell small-12">
          <Link
            to={{
              pathname: "/",
            }}
            className="button"
          >
            Go Back
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NoPlans;
